import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import {Slider} from 'react-slick';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import fetch from 'isomorphic-fetch';
import { browserHistory } from 'react-router';
import { checkHttpStatus, parseJSON } from '../../utils';
import './styles.scss';

const propTypes = {
  isOpen: PropTypes.bool
};

const contextTypes = {
  router: PropTypes.object
};

const defaultProps = {
  isOpen: false
};

class SearchView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      results: [],
      query: ''
    }
    this.closeSearch = this.closeSearch.bind(this);
    this.updateQuery = this.updateQuery.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if(nextProps.isOpen && !this.props.isOpen) {
      setTimeout(function() {
        ReactDOM.findDOMNode(this.refs.searchInput).focus();
      }.bind(this), 0);
    }
    if(this.context.router.params.term) {
      var term = this.context.router.params.term;
      if(this.state.query.length === 0 && term !== this.state.query) {
        this.setState({query: this.context.router.params.term});
      }
    } else {
      if(this.state.query.length > 0 && !nextProps.isOpen) {
        this.setState({query: ''});
      }
    }
  }

  closeSearch() {
    this.setState({ results: [] }, () => this.props.onIsOpenChanged(false));
  }

  handleKeyPress(e) {
    if(e.key === 'Enter') {
      browserHistory.push('/search/' + encodeURIComponent(e.currentTarget.value));
      this.props.onIsOpenChanged(false);
    }
  }

  updateQuery(e){
    this.setState({query: e.target.value});
  }

  render () {
    let closeSearch = this.closeSearch;
    return (
      <div className={this.props.isOpen ? "search-panel is-open" : "search-panel"}>
        <div className="search-box">
          <span className="close-search" onClick={closeSearch}><i className="icon-X_Close_Square"></i></span>
          <input
            ref="searchInput"
            className="search-field text-center"
            placeholder="SEARCH EXPLORE"
            value={this.state.query}
            onChange={this.updateQuery}
            onKeyPress={this.handleKeyPress}
          />
        </div>
      </div>
    );
  }
}

SearchView.propTypes = propTypes;
SearchView.contextTypes = contextTypes;
SearchView.defaultProps = defaultProps;

export default SearchView;
